import Footer from '@/components/Footer';
import MamapediaHeader from '@/components/Header/MamapediaHeader';
import MamapediaCategory from '@/components/Mamapedia/MamapediaCategory';


const MamapediaCategoryPage = () => {
  return (
    <>
      <MamapediaHeader />
      <MamapediaCategory />
      <Footer />
    </>
  )
}

export default MamapediaCategoryPage
